import { render, staticRenderFns } from "./SplashContent.vue?vue&type=template&id=197e22ea"
import script from "./SplashContent.vue?vue&type=script&lang=js"
export * from "./SplashContent.vue?vue&type=script&lang=js"
import style0 from "./SplashContent.vue?vue&type=style&index=0&id=197e22ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports